import { PartnerRole } from 'src/common/static'
import { useAuth } from './ProvideAuth'

export const useRoles = () => {
  const { roles } = useAuth()
  const has = (role: PartnerRole): boolean => roles.includes(role)
  return {
    roles,
    isPartnerOps: has(PartnerRole.OPS),
    isPartnerFinance: has(PartnerRole.FINANCE),
    hasAnyRole: (...rolesToCheck: PartnerRole[]): boolean => rolesToCheck.some(has)
  }
}
